import { render, staticRenderFns } from "./MyPage.vue?vue&type=template&id=5e080ff1&scoped=true&"
import script from "./MyPage.vue?vue&type=script&lang=js&"
export * from "./MyPage.vue?vue&type=script&lang=js&"
import style0 from "./MyPage.vue?vue&type=style&index=0&id=5e080ff1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e080ff1",
  null
  
)

export default component.exports